export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7192.dbb3c097.jpg";